import { ROUTES } from './routesEnums';
import { LatestSettlementsList } from '../components/settlements/LatestSettlementsList';
import { AllSettlementsList } from '../components/settlements/AllSettlementsList';

export enum SETTLEMENTS_TABS {
  LATEST_SETTLEMENTS = 'latest',
  ALL_SETTLEMENTS = 'all',
}

export const getSettlementsBaseUrls = (isSuperAdmin: boolean): string => isSuperAdmin ? `${ROUTES.FUNDS}${ROUTES.SETTLEMENTS}` : ROUTES.SETTLEMENTS;

export const getSettlementsRoutes = (isSuperAdmin: boolean): any[] => [
  {
    key: 'latest',
    pathname: `${getSettlementsBaseUrls(isSuperAdmin)}${ROUTES.LATEST_SETTLEMENTS}`,
    component: <LatestSettlementsList />
  },
  {
    key: 'all',
    pathname: `${getSettlementsBaseUrls(isSuperAdmin)}${ROUTES.ALL_SETTLEMENTS}`,
    component: <AllSettlementsList />
  },
];

export const settlementsTabs = [
  {
    label: 'Latest settlements',
    value: SETTLEMENTS_TABS.LATEST_SETTLEMENTS,
  },
  {
    label: 'All settlements',
    value: SETTLEMENTS_TABS.ALL_SETTLEMENTS,
  },
];

export const getInitialSettlementsNavTab = (pageName: string, isSuperAdmin: boolean): SETTLEMENTS_TABS => {
  switch (pageName) {
    case `${getSettlementsBaseUrls(isSuperAdmin)}${ROUTES.LATEST_SETTLEMENTS}`:
      return SETTLEMENTS_TABS.LATEST_SETTLEMENTS;
    case `${getSettlementsBaseUrls(isSuperAdmin)}${ROUTES.ALL_SETTLEMENTS}`:
      return SETTLEMENTS_TABS.ALL_SETTLEMENTS;
    default:
      return SETTLEMENTS_TABS.LATEST_SETTLEMENTS;
  }
};